<template>
  <a-modal
    v-model:visible="state.modalShowRMADetail"
    centered
    width="100%"
    wrapClassName="full-modal"
    :maskClosable="false"
  >
    <div class="antd-pro-pages-dashboard-analysis-twoColLayout product-detail-model-body">
      <a-row :gutter="24" type="flex">
        <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="24">
          <a-card :bordered="false" :title="t('route.RMAInformation')">
            <a-row :gutter="24">
              <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="24">
                <a-image
                  width="150px"
                  size="large"
                  shape="square"
                  :src="currentShowRMA.img"
                  fallback="data:image/png;base64,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"
                />
                <br/><br/><br/>
                <span><b class="font14">{{ currentShowRMA.product_sku }}</b>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{ currentShowRMA.product_size }}</span>
              </a-col>
              <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="24" class="order-info-col">
                <a-row>
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                    <b class="font14">{{ $t('route.RMA') }}</b>
                  </a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    <span><b class="font14">{{ currentShowRMA.RmaID }}</b></span>
                  </a-col>
                </a-row>
                <br/>
                <a-row :gutter="24" class="marginBottom8">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                    {{ $t('productDetail.orderNumber') }}:
                  </a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    {{ currentShowRMA.origin_invoice_number }}
                  </a-col>
                </a-row>

                <a-row :gutter="24" class="marginBottom8">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                    {{ $t('productDetail.orderID') }}:
                  </a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    {{ currentShowRMA.order_number }}
                  </a-col>
                </a-row>

                <a-row :gutter="24" class="marginBottom8" v-if="currentShowRMA.invoice_number && currentShowRMA.invoice_number != ''">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                    {{ $t('productDetail.InvoiceNumber') }}:
                  </a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    {{ currentShowRMA.invoice_number }}
                  </a-col>
                </a-row>

                <a-row :gutter="24" class="marginBottom8" v-if="currentShowRMA.warranty_card && currentShowRMA.warranty_card != ''">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                    {{ $t('productDetail.WarrantyCardNumber') }}:
                  </a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    {{ currentShowRMA.warranty_card }}
                  </a-col>
                </a-row>

                <a-row :gutter="24" class="marginBottom8" v-if="currentShowRMA.wh_carrier_name != ''">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                    {{ $t('ExpressDelivery.ExpressDeliveryCompany') }}:
                  </a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    {{ currentShowRMA.wh_carrier_name  }}
                  </a-col>
                </a-row>

                <a-row :gutter="24" class="marginBottom8" v-if="currentShowRMA.retail_carrier_code != '' || currentShowRMA.wh_carrier_code != ''">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9" class="product_tracking">
                    <span>{{ $t('route.TrackingNumber') }}:</span>
                  </a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    {{ currentShowRMA.wh_carrier_code || currentShowRMA.retail_carrier_code }}
                    <a-button type="link" @click="editTrackingNumber" v-if="permission('#INTRANET::FRONT_update wh carrier code') && currentShowRMA.rma_status_id == 14">{{ $t('productDetail.edit') }}</a-button>
                  </a-col>
                </a-row>

                <a-row :gutter="24" class="marginBottom8">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                    {{ $t('route.OrderDate') }}:
                  </a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    {{ currentShowRMA.date_of_purchase }}
                  </a-col>
                </a-row>

                <a-row :gutter="24" class="marginBottom8">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                    {{ $t('route.Status') }}:
                  </a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    <a-tag :color="currentShowRMA.RmaStatus.ID === 17 ? 'volcano' : currentShowRMA.RmaStatus.ID === 16 ? 'green' : currentShowRMA.RmaStatus.ID > 2 ? 'geekblue' : 'warning'">
                      <span> {{ currentShowRMA.RmaStatus.Name }} </span>
                      <a-input-group compact v-if="state.onRmaEditMode == true">
                        <a-select default-value="Zhejiang">
                          <a-select-option value="Zhejiang">
                            {{ currentShowRMA.RmaStatus.Name }}
                          </a-select-option>
                          <a-select-option value="Jiangsu">
                            Jiangsu
                          </a-select-option>
                        </a-select>
                      </a-input-group>
                    </a-tag>
                  </a-col>
                </a-row>
                <a-row :gutter="24" class="marginBottom8">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                    {{ $t('route.Name') }}:
                  </a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    <span>{{ currentShowRMA.fullname }}</span>
                  </a-col>
                </a-row>
                <a-row :gutter="24" class="marginBottom8">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                    {{ $t('route.Email') }}:
                  </a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    <span>{{ currentShowRMA.email }}</span>
                  </a-col>
                </a-row>
                <a-row :gutter="24" class="marginBottom8">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                    {{ $t('route.Phone') }}:
                  </a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="phone-col floatLeft">
                    <span>+ {{ currentShowRMA.phone_code }} - {{ currentShowRMA.phone }}</span>
                    <img class="qrcode-icon" :src="phoneIcon" @click="showQrcode('phoneQrcode', $t('productDetail.ContactUsByPhone'))" />
                    <img class="qrcode-icon" :src="whatsappIcon" @click="showQrcode('whatsappQrcode', $t('productDetail.ContactUsByWhatsapp'))" />
                  </a-col>
                </a-row>
                <a-row :gutter="24" class="marginBottom8">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                    {{ $t('route.CreatedBy') }}:
                  </a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    <span>{{ currentShowRMA.shopName }} ({{ currentShowRMA.store_id }})</span>
                  </a-col>
                </a-row>
                <a-row :gutter="24" class="marginBottom8">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                    {{ $t('route.CreatedOn') }}:
                  </a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    <span>{{ formatDateWithTime(currentShowRMA.RmaStatusHistory[currentShowRMA.RmaStatusHistory.length - 1].CreatedAt) + " (UTC)" }}</span>
                  </a-col>
                </a-row>
                <a-row :gutter="24" class="marginBottom8">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                    {{ $t('productDetail.RepairFee') }}:
                  </a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    <span>{{ currentShowRMA.repair_fee }} {{ currentShowRMA.repair_fee > 0 ? currentShowRMA.repair_fee_ccy : '' }}</span>
                  </a-col>
                </a-row>
                <a-row :gutter="24" class="marginBottom8" v-if="currentShowRMA.shipping_fee != '' && currentShowRMA.shipping_fee > 0">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                    {{ $t('productDetail.ShippingFee') }}:
                  </a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    <span>{{ currentShowRMA.shipping_fee }} {{ currentShowRMA.shipping_fee_ccy }}</span>
                  </a-col>
                </a-row>
                <a-row :gutter="24" class="marginBottom8">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                    {{ $t('route.RepairTime') }}:
                  </a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    <span>{{ currentShowRMA.repair_history.total_180 }}</span>
                  </a-col>
                </a-row>
                <a-row :gutter="24" class="marginBottom8" v-if="currentShowRMA.rma_gold_goods_history.id > 0">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                    {{ $t('productDetail.SequenceNo') }}:
                  </a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    <span>{{ currentShowRMA.rma_gold_goods_history.cert_no }}</span>
                  </a-col>
                </a-row>
                <a-row :gutter="24" class="marginBottom8" v-if="currentShowRMA.rma_gold_goods_history.id > 0">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                    {{ $t('productDetail.totalWeight') }}:
                  </a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    <span>{{ currentShowRMA.rma_status_id >= 13 && currentShowRMA.rma_status_id <= 16 ? currentShowRMA.rma_gold_goods_history.gold_weight_after_repaired : currentShowRMA.rma_gold_goods_history.gold_weight_before_repaired }}</span>
                  </a-col>
                </a-row>
                <a-row :gutter="24" class="marginBottom8" v-if="!isShop">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                    {{ $t('productDetail.HavePuchaseRecord') }}:
                  </a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    <span v-if="currentShowRMA.isHasPuchaseRecords"><a-tag color="red">{{ $t('productDetail.yesPuchaseRecord') }}</a-tag></span>
                    <span v-else><a-tag color="green">{{ $t('productDetail.noPuchaseRecord') }}</a-tag></span>
                  </a-col>
                </a-row>
                <a-row :gutter="24" class="marginBottom8" v-if="currentShowRMA.rma_factory_sav_item && currentShowRMA.rma_factory_sav_item.version">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                    {{ $t('route.Version') }}:
                  </a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    <span>{{ currentShowRMA.rma_factory_sav_item?.version || '-' }}</span>
                  </a-col>
                </a-row>
                <a-row :gutter="24" class="marginBottom8" v-if="currentShowRMA.is_local_repair">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                    {{ $t('route.LocalRepair') }}:
                  </a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    <span>YES</span>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
            <a-divider />
            <a-row :gutter="24" class="mail-info-box" v-if="currentShowRMA.receiver_name || currentShowRMA.receiver_phone || currentShowRMA.customer_province || currentShowRMA.customer_address || currentShowRMA.customer_postal_code">
              <b class="font14 mail-info"> {{ $t('route.mailingInformation') }}: </b>
              <a-col :span="24">
                <a-row :gutter="24" v-if="currentShowRMA.receiver_name">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9"></a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    <a-row :gutter="24" class="marginBottom8">
                      <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                        {{ $t('route.receiverName') }}:
                      </a-col>
                      <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                        <span>{{ currentShowRMA.receiver_name }}</span>
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
                <a-row :gutter="24" class="marginBottom8" v-if="currentShowRMA.receiver_phone">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9"></a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    <a-row :gutter="24">
                      <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                        {{ $t('route.receiverPhone') }}:
                      </a-col>
                      <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                        <span>{{ currentShowRMA.receiver_phone }}</span>
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
                <a-row :gutter="24" class="marginBottom8" v-if="currentShowRMA.customer_province">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9"></a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    <a-row :gutter="24">
                      <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                        {{ $t('route.province') }}:
                      </a-col>
                      <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                        <span>{{ currentShowRMA.customer_province }} {{ currentShowRMA.customer_city }} {{ currentShowRMA.customer_area }}</span>
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>

                <a-row :gutter="24" class="marginBottom8" v-if="!currentShowRMA.customer_province && currentShowRMA.customer_country_or_reigon">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9"></a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    <a-row :gutter="24">
                      <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                        {{ $t('route.cityAndcountry') }}:
                      </a-col>
                      <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                        <span>{{ currentShowRMA.customer_country_or_reigon ? `${currentShowRMA.customer_city} / ${currentShowRMA.customer_country_or_reigon}` : '' }}</span>
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>

                <a-row :gutter="24" class="marginBottom8" v-if="currentShowRMA.customer_address">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9"></a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    <a-row :gutter="24">
                      <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                        {{ $t('route.address') }}:
                      </a-col>
                      <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                        <span>{{ currentShowRMA.customer_address }} {{ currentShowRMA.customer_country_code ? `/ ${currentShowRMA.customer_city} / ${currentShowRMA.customer_country_code}` : '' }}</span>
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
                <a-row :gutter="24" class="marginBottom8" v-if="currentShowRMA.customer_postal_code">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9"></a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    <a-row :gutter="24">
                      <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9">
                        {{ $t('route.postalCode') }}:
                      </a-col>
                      <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                        <span>{{ currentShowRMA.customer_postal_code }}</span>
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
                <a-row :gutter="24" class="marginBottom8" v-if="permission('#INTRANET::FRONT_edit customer shipping address')">
                  <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="9"></a-col>
                  <a-col :xl="14" :lg="14" :md="14" :sm="14" :xs="14" class="floatLeft">
                    <a-row :gutter="24">
                      <a-button key="submit" type="primary" @click="openShippingAddressModel" >{{ $t('productDetail.edit') }}</a-button>
                    </a-row>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
            <a-divider v-if="currentShowRMA.receiver_name || currentShowRMA.receiver_phone || currentShowRMA.customer_province || currentShowRMA.customer_address || currentShowRMA.customer_postal_code" />
            <a-row :gutter="24">
              <b class="font14 factory-remark"> {{ $t("route.factoryRemark") }}: </b>
              <a-col :span="20">
                <a-collapse v-model:activeKey="fcomments_activeKey" :bordered="false" expandIconPosition="right" v-if="state.factoryComment.length > 0">
                  <template #expandIcon="{ isActive }">
                    <span>
                      {{ $t("route.more") }}
                      <caret-right-outlined :rotate="isActive ? 90 : 0" />
                    </span>
                  </template>
                  <a-collapse-panel key="1" :header="currentShowRMA.fcomments" class="border0">
                    <a-row :gutter="24" class="remark" v-for="item in state.factoryComment" :key="item.id">
                      <a-col :span="16">{{ item.index }}. {{ formatDateWithTime(item.created_at) }} {{ item.comment }}</a-col>
                      <a-col :span="8">{{ $t('route.By') }}: <span class="create_by">{{ item.created_by }}</span></a-col>
                    </a-row>
                  </a-collapse-panel>
                </a-collapse>
              </a-col>
              <a-form ref="formRef" :model="formState" :rules="rules" class="w100" v-if="permission('#INTRANET::FRONT_edit factory comment')">
                <a-form-item name="fcomments" :wrapperCol="{span: 24}" class="marginBottom0">
                  <a-textarea
                    v-model:value="formState.fcomments"
                    :placeholder="$t('route.InputFactoryRemarkHere')"
                    :auto-size="{ minRows: 2, maxRows: 5 }"
                    :maxlength="120"
                  />
                </a-form-item>
              </a-form>
              <a-button v-if="permission('#INTRANET::FRONT_edit factory comment')" type="primary" block @click="handleUpdateOperationComment(currentShowRMA)">{{ $t("route.updateRemark") }}</a-button>
            </a-row>
            <a-divider />
            <br/>
            <a-row :gutter="24">
              <b class="font14 store-remark"> {{ $t("route.StoreRemark") }}: </b>
              <a-col :span="20">
                <a-collapse v-model:activeKey="scomments_activeKey" :bordered="false" expandIconPosition="right" v-if="state.storeComment.length > 0">
                  <template #expandIcon="{ isActive }">
                    <span>
                      {{ $t("route.more") }}
                      <caret-right-outlined :rotate="isActive ? 90 : 0" />
                    </span>
                  </template>
                  <a-collapse-panel key="1" :header="currentShowRMA.scomments" class="border0">
                    <a-row :gutter="24" class="remark" v-for="item in state.storeComment" :key="item.id">
                      <a-col :span="16">{{ item.index }}. {{ formatDateWithTime(item.created_at) }} {{ item.comment }}</a-col>
                      <a-col :span="8">{{ $t('route.By') }}: <span class="create_by">{{ item.created_by }}</span></a-col>
                    </a-row>
                  </a-collapse-panel>
                </a-collapse>
              </a-col>
              <a-form ref="formRef" :model="formState" :rules="rules" class="w100" v-if="permission('#INTRANET::FRONT_edit shop comment')">
                <a-form-item name="fcomments" :wrapperCol="{span: 24}" class="marginBottom0">
                  <a-textarea
                    v-model:value="formState.scomments"
                    :placeholder="$t('route.InputFactoryRemarkHere')"
                    :auto-size="{ minRows: 2, maxRows: 5 }"
                    :maxlength="120"
                  />
                </a-form-item>
              </a-form>
              <a-button v-if="permission('#INTRANET::FRONT_edit shop comment')" type="primary" block @click="handleUpdateStoreComment(currentShowRMA)">{{ $t("route.updateRemark") }}</a-button>
            </a-row>
            <br/>
            <a-row :gutter="24" v-if="currentShowRMA.signUrl">
              <b class="font14 pb12px"> {{ $t("route.customerSign") }}: </b>
              <a-image
                :width="500"
                :src="currentShowRMA.signUrl"
                class="desc-images"
              />
            </a-row>
            <br v-if="currentShowRMA.signUrl"/>
            <a-row :gutter="24" v-if="!isShop && currentShowRMA.RmaItemFakeProduct.id != 0">
              <a-row class="w100"><b class="font14 pb12px"> {{ $t("productDetail.fakesInfo") }}: </b></a-row>
              <a-row class="w100 mb12px">
                <span class="fakes-into-title">{{ $t("productDetail.fakesInfoImage") }}:</span>
                <div class="fakes-into-images">
                  <a-image
                    v-for="item in currentShowRMA.RmaItemFakeProduct.rma_item_fake_attachment"
                    :key="item.id"
                    :src="item.folder_path"
                    class="desc-images fakes-into-image"
                    :width="300"
                  />
                </div>
              </a-row>
              <a-row class="w100">
                <span class="fakes-into-title">{{ $t("productDetail.fakesInfoRemark") }}:</span>
                <span class="fakes-remark">{{ currentShowRMA.RmaItemFakeProduct.fake_remark }}</span>
              </a-row>
            </a-row>
            <br v-if="!isShop && currentShowRMA.RmaItemFakeProduct.id != 0"/>
            <!-- <a-row :gutter="24">
              <b class="font14 paddingBottom8">{{ $t('route.OptionalComments') }}:&nbsp</b>
              {{ currentShowRMA.scomments }}
            </a-row> -->
            <!-- <br/> -->
            <a-row :gutter="24">
              <a-col :xl="8" :lg="12" :md="12" :sm="12" :xs="24">
                <b class="font14">{{ $t('route.StoreReasons') }}: </b>
                <div>
                  <span v-for="reason in currentShowRMA.rma_item_to_reason" :key="reason.ID">
                    <span v-if="reason.rma_item_reason_id == 13">
                      <a-tag class="reason_span">{{ $t("reasonsName."+covertToCamelCase(reason.Name)) }}</a-tag>
                      <a-tag class="reason_span" v-for="item in reason.RenewRmaReason" :key="item.ID">{{ $t("reasonsName.Renew") }}: {{ $t("reasonsName."+covertToCamelCase(item.Name)) }}</a-tag>
                    </span>
                    <a-tag class="reason_span" v-else>{{ $t("reasonsName."+covertToCamelCase(reason.Name)) }}</a-tag>
                  </span>
                </div>
              </a-col>
              <a-col :xl="8" :lg="12" :md="12" :sm="12" :xs="24">
                <b class="font14">{{ $t('route.FactoryReasons') }}: </b>
                <div>
                  <div class="factory_reason_box" v-for="reason in currentShowRMA.rma_factory_sav_reason" :key="reason.ID">
                    <div class="factory_reason_box_left">
                      <a-tag class="reason_span" :color="currentShowRMA.diff_reason_count > 0 ? 'red' : ''">{{ $t("reasonsName."+covertToCamelCase(reason.Name)) }}</a-tag>
                    </div>
                    <div class="factory_reason_box_right" v-if="reason.RmaReasonSubreason != null">
                      <a-tag class="reason_span"  v-for="subreason in reason.RmaReasonSubreason" color="orange">{{ $t("reasonsName.sub") }} {{ $t("reasonsName."+covertToCamelCase(subreason.name)) }}</a-tag>
                    </div>
                  </div>
                </div>
              </a-col>
              <a-col :xl="8" :lg="12" :md="12" :sm="12" :xs="24">
                <b class="font14 paddingBottom8">{{ $t('route.Attachment') }}: </b>
                <a-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                  <a-row :gutter="24">
                    <a-col
                      :xl="8"
                      :lg="8"
                      :md="8"
                      :sm="8"
                      :xs="8"
                      v-for="attachment in currentShowRMA.RmaItemAttachment"
                      :key="attachment.ID"
                      class="paddingBottom12"
                    >
                      <a-image
                        width="80px"
                        height="80px"
                        size="large"
                        shape="square"
                        :src="attachment.FolderPath"
                        class="attachment-image"
                      />
                    </a-col>
                  </a-row>
                </a-col>
              </a-col>
            </a-row>
          </a-card>
        </a-col>
        <div class="vl"></div>
        <a-col :xl="9" :lg="9" :md="9" :sm="9" :xs="24">
          <a-card :bordered="false" :title="t('route.RMAStatus')" class="pl0 pr0">
            <a-row :gutter="68">
              <a-col :xs="24" :sm="24" class="mb24px">
                <a-timeline>
                  <a-timeline-item v-for="statusHistory in currentShowRMA.RmaStatusHistory.sort((a,b) => b.ID - a.ID )" :key="statusHistory.ID">
                    <a-row>
                      <a-col :xl="10" :lg="24" :md="24" :sm="24" :xs="24">
                        <span :class="statusHistory.Remark =='Not APM Product' ? 'rma-status-text reject-operation-status' : 'rma-status-text'">{{ statusHistory.RmaStatus.Name }}</span>
                      </a-col>
                      <a-col :xl="14" :lg="24" :md="24" :sm="24" :xs="24" v-if="statusHistory.RmaCarrierTracking != '' && statusHistory.Remark !='Not APM Product'">
                        <span class="rma-status-text">{{ statusHistory.RmaCarrierTracking }}</span>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col :xl="10" :lg="24" :md="24" :sm="24" :xs="24">
                        <span class="rma-status-text">{{ formatDateWithTime(statusHistory.CreatedAt) + " (UTC)" }}</span>
                      </a-col>
                      <a-col :xl="14" :lg="24" :md="24" :sm="24" :xs="24">
                        <span class="rma-status-text">{{ $t('route.By') }}: {{ statusHistory.CreatedBy }}</span>
                      </a-col>
                    </a-row>
                  </a-timeline-item>
                </a-timeline>
              </a-col>
            </a-row>
          </a-card>
          <a-card :bordered="false" :title="t('productDetail.pickupFollowup')" class="pl0 pr0" v-if="currentShowRMA.rma_status_id == 15">
            <a-row :gutter="68">
              <a-col :xs="24" :sm="24" class="mb24px">
                <a-form-item :label="t('productDetail.contactLabel')">
                  <div class="display_flex">
                    <a-select v-model:value="contactResult" :placeholder="t('productDetail.pleaseSelectContactResult')" allowClear>
                      <a-select-option value="Phone: Contacted">{{ $t('productDetail.Phone: Contacted') }}</a-select-option>
                      <a-select-option value="Phone: No answer">{{ $t('productDetail.Phone: No answer') }}</a-select-option>
                      <a-select-option value="Whatsapp: Reminder Sent">{{ $t('productDetail.Whatsapp: Reminder Sent') }}</a-select-option>
                      <a-select-option value="Wechat: Reminder Sent">{{ $t('productDetail.Wechat: Reminder Sent') }}</a-select-option>
                      <a-select-option value="Email : Reminder Sent">{{ $t('productDetail.Email : Reminder Sent') }}</a-select-option>
                    </a-select>
                    <a-button type="primary" @click="onSubmitPickupFollowup">{{ $t('route.submit') }}</a-button>
                  </div>
                </a-form-item>
                <div v-if="state.pickupFollowUpList.length == 0" class="empty-result">
                  <span>{{ $t('productDetail.EmptyFollowUpList') }}</span>
                </div>
                <a-timeline v-else>
                  <a-timeline-item v-for="FollowUpHistory in state.pickupFollowUpList" :key="FollowUpHistory.ID"> 
                    <a-row>
                      <a-col :xl="10" :lg="24" :md="24" :sm="24" :xs="24">
                        <span class="rma-status-text">{{ formatDateWithTime(FollowUpHistory.created_at) + " (UTC)" }}</span>
                      </a-col>
                      <a-col :xl="14" :lg="24" :md="24" :sm="24" :xs="24">
                        <span class="rma-status-text font-bold">{{ $t('productDetail.' + FollowUpHistory.content) }}</span>
                      </a-col>
                    </a-row>
                  </a-timeline-item>
                </a-timeline>
              </a-col>
            </a-row>
          </a-card>
        </a-col>
      </a-row>
    </div>

    <template #footer>
      <div class="footer-btn-box">
        <div class="footer-btns">
          <span class="marginRight20" v-if="(currentShowRMA.rma_status_id == 1 && state.onRmaEditMode == false && isShop) || permission('#INTRANET::FRONT_view cancel order')"> <a-button @click="handleCancelRMA(currentShowRMA)" danger>{{ $t('route.DeleteRMA') }}</a-button></span>
          <span class="marginRight20" v-if="currentShowRMA.rma_status_id > 0 && state.onRmaEditMode == false && !isShop"> <a-button @click="rejectOperation(currentShowRMA)" danger>{{ $t('route.reject') }}</a-button></span>
          <span class="marginRight20" v-if="currentShowRMA.rma_status_id > 0 && currentShowRMA.rma_status_id != 17 && state.onRmaEditMode == false" > <a-button type="primary" @click="reprintLabel" >{{ $t('listRMA.printLabel') }}</a-button> </span>
    
          <span class="marginRight20" v-if="(currentShowRMA.rma_status_id == 15 || currentShowRMA.rma_status_id == 21 || currentShowRMA.rma_status_id == 22) && state.onRmaEditMode == false"> <a-button type="primary" @click="confirmPickup(currentShowRMA)" >{{ $t('route.confirmCustomerPickup') }}</a-button> </span>
    
          <span class="marginRight20" v-if="(currentShowRMA.rma_status_id == 14 || currentShowRMA.rma_status_id == 15) && state.onRmaEditMode == false"> <a-button type="primary" @click="reject(currentShowRMA)" >{{ $t('route.reject') }}</a-button> </span>

          <span class="marginRight20" v-if="currentShowRMA.rma_status_id > 2 && state.onRmaEditMode == false && !isShop"> <a-button @click="uploadFakesInfo(currentShowRMA)" danger>{{ $t('productDetail.fakesInfoUpload') }}</a-button></span>
        </div>

        <span class="footer-btn-close">
          <a-button key="submit" type="primary" @click="modalClose" >{{ $t('tagsView.close') }}</a-button>
        </span>
      </div>
    </template>

    <!-- Reprint Label -->
    <a-modal
      title="Print Label"
      centered
      :footer="null"
      v-model:visible="state.modalShowPrintLabel"
    >
      <div v-if="!state.showPrintAction" class="text-center pt20px pb20px">
        <a-spin size="large" />
      </div>
      <div class="print-modal" v-else>
        <div class="print-modal-left">
          <a :href="state.labelUrl" target="_blank" class="link-button">
            {{ $t("listRMA.printLabel") }}
          </a>
        </div>
        <div class="print-modal-right">
          <div class="package" v-if="state.packageUrl !== ''">
            <a :href="state.packageUrl" target="_blank" class="link-button">
              {{ $t("listRMA.printPackageList") }}
            </a>
          </div>
          <div class="package" v-if="state.abandonedPackageUrl !== ''">
            <a :href="state.abandonedPackageUrl" target="_blank" class="link-button">
              {{ $t("listRMA.printAbandonedPackageList") }}
            </a>
          </div>
        </div>
      </div>
    </a-modal>
    <!-- End Reprint Label -->
    <!-- VueSignaturePad -->
    <a-modal 
      title="Sign Label"
      centered
      width="75%"
      :maskClosable="false"
      :footer="null"
      :visible="state.isShowSign"
      @cancel="closeSignFn"
      class="signature-pad-box"
    >
      <div class="signature-pad">
        <VueSignaturePad width="100%" height="480px" ref="signaturePad" :options="options" />
      </div>
      <div class="display_flex signature-pad-btnbox">
        <a-button type="primary" @click="saveFn(currentShowRMA)">{{ $t("route.save") }}</a-button>
        <a-button type="primary" @click="undoFn">{{ $t('productDetail.undo') }}</a-button>
        <a-button type="primary" @click="clearFn">{{ $t("route.clear") }}</a-button>
      </div>
    </a-modal>
    <!-- End VueSignaturePad -->
    <a-modal
      :title="$t('listRMA.rejectReasonTitle')"
      centered
      :maskClosable="false"
      :visible="rejectReasonModel"
      @ok="handleRejectReasonOk"
      @cancel="rejectReasonModel = false"
    >
      <a-select
        ref="select"
        class="w100"
        v-model:value="state.rejectReasonValue"
        :placeholder="$t('listRMA.pleaseSelectRejectReason')"
      >
        <a-select-option v-for="item in state.rejectReasons" :key="item.id" :value="item.id">{{ $t("reasonsName."+covertToCamelCase(item.name)) }}</a-select-option>
      </a-select>
    </a-modal>
    <a-modal
      :title="$t('productDetail.fakesInfoUpload')"
      centered
      :maskClosable="false"
      :visible="fakeProductModel"
      @ok="handleFakeProductOk"
      @cancel="closeFakesInfoModel"
      class="fake-product-modal"
    >
      <a-form :label-col="{ style: { width: '100px' } }" :wrapper-col="{ span: 24 }">
        <a-form-item :label="$t('productDetail.uploadFakesInfo')">
          <a-upload
            list-type="picture"
            v-model:file-list="fakeInfoState.fileList"
            @preview="handlePreview"
            :before-upload="beforeUpload"
          >
            <a-button :disabled="fakeInfoState.fileList.length > 1">
              <upload-outlined></upload-outlined>
              {{ $t('productDetail.uploadFakesInfo') }}
            </a-button>
          </a-upload>
        </a-form-item>
        <a-form-item :label="$t('productDetail.remark')">
          <a-textarea v-model:value="fakeInfoState.remark" :rows='4' />
        </a-form-item>
      </a-form>
      <a-modal class="fake-product-image-modal" :visible="previewVisible" :footer="null" @cancel="handleCancel">
        <img alt="example" class="w100" :src="previewImage" />
      </a-modal>
    </a-modal>
    <a-modal
      :title="$t('productDetail.editTrackingNumberModal')"
      centered
      :maskClosable="false"
      :visible="editTrackingNumberModel"
      @ok="handleEditTrackingNumberOk"
      @cancel="closeTrackingNumberModel"
    >
      <a-form :model="formState" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
        <a-form-item :label="$t('productDetail.Delivery')">
          <a-select
            ref="carrier_select"
            class="w100"
            v-model:value="selectDelivery"
            :placeholder="$t('productDetail.pleaseSelectDelivery')"
          >
            <a-select-option v-for="item in delivery_list" :key="item.id" :value="item.carrier_name">{{ item.carrier_name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('productDetail.newTrackingNumber')">
          <a-input v-model:value="newTrackingNumber" :placeholder="$t('productDetail.pleaseInputNewTrackingNumber')" />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal v-model:visible="qrcodeState.qrcodeVisible" :title="qrcodeState.qrcodeTitle" :footer="null" :afterClose="closeQrcodeModal">
      <div class="qrcode-preview">
        <div id="qrcode"></div>
      </div>
    </a-modal>
    <a-modal v-model:visible="shippingAddressModel" :title="$t('productDetail.editShippingAddress')" :footer="null" :afterClose="closeQrcodeModal">
      <a-form :model="shippingAddressForm" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
        <a-form-item :label="$t('route.DeliverToCustomer')">
          <a-switch :checked="isShipToCustomer" @change="handleShipToCustomerChange" />
        </a-form-item>
        <a-form-item v-if="!isShipToCustomer" :label="$t('productDetail.shipToStore')">
          <a-select
            v-model:value="shippingAddressForm.store_id"
            show-search
            optionFilterProp="label"
            :placeholder="$t('productDetail.pleaseSelectStore')"
          >
            <a-select-option
              v-for="store in storeList"
              :key="store.store_id"
              :value="String(store.store_id)"
              :label="`${store.name} (${store.store_id})`"
            >
              {{ store.name }} ({{ store.store_id }})
            </a-select-option>
          </a-select>
        </a-form-item>
        <template v-if="isShipToCustomer">
          <a-form-item v-if="shippingAddressNeedCountry" :label="$t('createRMA.Country')">
            <a-select
              v-model:value="shippingAddressForm.customer_country_code"
              show-search
              optionFilterProp="label"
              @change="handleShippingCountryChange"
            >
              <a-select-option
                v-for="country in boutiqueCountryList"
                :key="country.value"
                :value="country.iso_code_3"
                :label="country.en_name"
                :disabled="!country.is_shippable"
              >
                <span>{{ country.en_name }}</span>
                <span class="boutique_country_red" v-if="country.is_shippable">{{ t('createRMA.Allow') }}</span>
                <span class="boutique_country_green" v-else>{{ t('createRMA.Deny') }}</span>
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :label="$t('productDetail.customerProvince')">
            <a-input v-model:value="shippingAddressForm.customer_province" :placeholder="$t('productDetail.pleaseInputCustomerProvince')" />
          </a-form-item>
          <a-form-item :label="$t('productDetail.customerCity')">
            <a-input v-model:value="shippingAddressForm.customer_city" :placeholder="$t('productDetail.pleaseInputCustomerCity')" />
          </a-form-item>
          <a-form-item :label="$t('productDetail.customerArea')">
            <a-input v-model:value="shippingAddressForm.customer_area" :placeholder="$t('productDetail.pleaseInputCustomerArea')" />
          </a-form-item>
          <a-form-item :label="$t('productDetail.customerAddress')">
            <a-input v-model:value="shippingAddressForm.customer_address" :placeholder="$t('productDetail.pleaseInputCustomerAddress')" />
          </a-form-item>
          <a-form-item :label="$t('productDetail.receiverName')">
            <a-input v-model:value="shippingAddressForm.receiver_name" :placeholder="$t('productDetail.pleaseInputReceiverName')" />
          </a-form-item>
          <a-form-item :label="$t('productDetail.receiverPhone')">
            <a-input v-model:value="shippingAddressForm.receiver_phone" :placeholder="$t('productDetail.pleaseInputReceiverPhone')" />
          </a-form-item>
          <a-form-item :label="$t('productDetail.customerPostalCode')">
            <a-input v-model:value="shippingAddressForm.customer_postal_code" :placeholder="$t('productDetail.pleaseInputCustomerPostalCode')" />
          </a-form-item>
        </template>
        <a-form-item :wrapper-col="{ span: 24 }">
          <div class="modify-shipping-address-btn">
            <a-button @click="handleUpdateShippingAddress">{{ $t('productDetail.updateShippingAddress') }}</a-button>
            <a-button type="primary" @click="shippingAddressModel = false">{{ $t('tagsView.close') }}</a-button>
          </div>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-modal>
</template>
<script>
  import { ref, reactive, defineComponent, createVNode, watch, nextTick, computed } from 'vue'
  import { getCurrentInstance, onMounted } from '@vue/runtime-core'
  import { formatDateWithTime, compressImage } from '@/utils/utils'
  import useRmaRepositories from "@/composables/useRmaRepositories"
  import { message, Modal, notification } from 'ant-design-vue';
  import { SearchOutlined, ExclamationCircleOutlined, CaretRightOutlined, PlusOutlined, UploadOutlined } from "@ant-design/icons-vue";
  import { useI18n } from 'vue-i18n'
  import { fetchSaveSign } from "@/services/rmaRepositories";
  import useListRmaRepositories from "@/composables/useListRmaRepositories"
  // import imageCompression from 'browser-image-compression';
  import phoneIcon from '@/assets/phone-outgoing-svgrepo-com.svg'
  import whatsappIcon from '@/assets/whatsapp-svgrepo-com.svg'
  import QRCode from '@/utils/qrcode.min.js'
  
  export default defineComponent ({
    name: 'ProductDetail',
    // props: ['showRMADetail', 'stateData'],
    props: {
      showRMADetail: {
        type: Object,
        default: null
      },
      stateData: {
        type: Function,
        default: null
      }
    },
    emits: ['updateData'],
    components: {
      ExclamationCircleOutlined,
      CaretRightOutlined,
      PlusOutlined,
      UploadOutlined
    },
    setup(props, context) {
      const { printPackageList, updateRmaStatus, printItemLabel, updateOperationComment, updateStoreComment, getComments, uploadFakeProduct, delivery_list, postUpdateTrackingNumber, postUpdateAfterSales, postUpdateShippingAddress, getBoutiqueCountryList } = useRmaRepositories()
      const { selectedItem, state, setSelectedItem, getPickupFollowUpList } = props.stateData()
      const { t ,locale } = useI18n({ useScope: 'global' })
      const isShop = localStorage.getItem("usertype") === "shop"
      const formRef = ref()
      const currentInstance = getCurrentInstance()
      const { proxy } = getCurrentInstance();
      const options = {
        backgroundColor:'rgba(255, 255, 255, 1)'
      }
      const { getSomeOfRmaListData } = useListRmaRepositories()
      const rules = ref({
        fcomments: [
          {
            message: t('route.TextLengthIsTooLong'),
            trigger: 'change',
            max: 120
          }
        ]
      })
      const formState = reactive({
        fcomments: '',
        scomments: ''
      })
      const scomments_activeKey = ref('')
      const fcomments_activeKey = ref('')
      const rejectReasonModel = ref(false)
      const editTrackingNumberModel = ref(false)
      const selectDelivery = ref('')
      const newTrackingNumber = ref('')
      const qrcodeState = reactive({
        qrcodeVisible: false,
        qrcodePlugin: null,
        qrcodeTitle: ''
      })
      const contactResult = ref()
      const shippingAddressModel = ref(false)
      const shippingAddressNeedCountry = ref(false)
      const boutiqueCountryList = ref([])
      const storeList = computed(() => state.storeList || [])

      let currentShowRMA = selectedItem

      const shippingAddressForm = reactive({
        wh_ship_to_customer: 0,
        store_id: undefined,
        customer_country_code: '',
        customer_country_or_reigon: '',
        customer_province: '',
        customer_city: '',
        customer_area: '',
        customer_address: '',
        receiver_name: '',
        receiver_phone: '',
        customer_postal_code: '',
      })

      const shippingAddressOrigin = reactive({
        id: '',
        store_id: '',
        customer_country_code: '',
        customer_country_or_reigon: '',
        customer_province: '',
        customer_city: '',
        customer_area: '',
        customer_address: '',
        receiver_name: '',
        receiver_phone: '',
        customer_postal_code: '',
      })

      const emptyText = (value) => (value == null ? '' : String(value))

      const snapshotShippingOrigin = (rma) => {
        shippingAddressOrigin.id = rma.id
        shippingAddressOrigin.store_id = rma.store_id ? String(rma.store_id) : ''
        shippingAddressOrigin.customer_country_code = emptyText(rma.customer_country_code)
        shippingAddressOrigin.customer_country_or_reigon = emptyText(rma.customer_country_or_reigon)
        shippingAddressOrigin.customer_province = emptyText(rma.customer_province)
        shippingAddressOrigin.customer_city = emptyText(rma.customer_city)
        shippingAddressOrigin.customer_area = emptyText(rma.customer_area)
        shippingAddressOrigin.customer_address = emptyText(rma.customer_address)
        shippingAddressOrigin.receiver_name = emptyText(rma.receiver_name)
        shippingAddressOrigin.receiver_phone = emptyText(rma.receiver_phone)
        shippingAddressOrigin.customer_postal_code = emptyText(rma.customer_postal_code)
      }

      const restoreAddressFromOrigin = () => {
        shippingAddressForm.customer_country_code = shippingAddressOrigin.customer_country_code
        shippingAddressForm.customer_country_or_reigon = shippingAddressOrigin.customer_country_or_reigon
        shippingAddressForm.customer_province = shippingAddressOrigin.customer_province
        shippingAddressForm.customer_city = shippingAddressOrigin.customer_city
        shippingAddressForm.customer_area = shippingAddressOrigin.customer_area
        shippingAddressForm.customer_address = shippingAddressOrigin.customer_address
        shippingAddressForm.receiver_name = shippingAddressOrigin.receiver_name
        shippingAddressForm.receiver_phone = shippingAddressOrigin.receiver_phone
        shippingAddressForm.customer_postal_code = shippingAddressOrigin.customer_postal_code
      }

      const isShipToCustomer = computed(() => Number(shippingAddressForm.wh_ship_to_customer) === 1)

      const handleShipToCustomerChange = (checked) => {
        shippingAddressForm.wh_ship_to_customer = checked ? 1 : 0
        if (!checked) {
          restoreAddressFromOrigin()
        }
      }

      const getStoreById = (storeId) => {
        return storeList.value.find(item => String(item.store_id) === String(storeId))
      }

      const resolveNeedCountry = (storeId) => {
        const store = getStoreById(storeId)
        shippingAddressNeedCountry.value = !(store && store.country_code === 'CHN')
      }

      const fillShippingAddressForm = (rma) => {
        snapshotShippingOrigin(rma)
        shippingAddressForm.wh_ship_to_customer = Number(rma.wh_ship_to_customer) === 1 ? 1 : 0
        shippingAddressForm.store_id = shippingAddressOrigin.store_id || undefined
        restoreAddressFromOrigin()
        resolveNeedCountry(rma.store_id)
      }

      const openShippingAddressModel = async () => {
        fillShippingAddressForm(currentShowRMA.value)
        if (shippingAddressNeedCountry.value && !boutiqueCountryList.value.length) {
          const result = await getBoutiqueCountryList()
          if (result.success) {
            boutiqueCountryList.value = result.data
          }
        }
        shippingAddressModel.value = true
      }

      const handleShippingCountryChange = (value) => {
        const country_item = boutiqueCountryList.value.filter(item => item.iso_code_3 == value)
        shippingAddressForm.customer_country_or_reigon = country_item.length > 0 ? country_item[0].en_name : ''
      }
      
      watch(currentShowRMA, (newValue, oldValue) => {
        formState.fcomments = newValue.fcomments
        formState.scomments = newValue.scomments
        fillShippingAddressForm(newValue)
      })

      const reprintLabel = async (rmaId, trackingCode) => {
        state.modalShowPrintLabel = true
        state.reprintTrackingCode = currentShowRMA.value.retail_carrier_code
        state.reprintID = currentShowRMA.value.id
        state.showPrintAction = false
        try {
          const resultPrintLabelURL = await handleRePrintLabel()
          state.labelUrl = resultPrintLabelURL.data.url
          // console.log(state.labelUrl, "state.labelUrl")
        } catch(err) {
          console.log(err)
        }
        try {
          const resultPackageListURL = await handleRePrintPackageList()
          state.packageUrl = resultPackageListURL.data.url_list.repair_url
          state.abandonedPackageUrl = resultPackageListURL.data.url_list.abandoned_url
          // console.log(state.packageUrl, "state.packageUrl")
        } catch(err) {
          console.log(err)
        }
        state.showPrintAction = true
      }

      const handleRePrintLabel = async () =>{
        const result = await printItemLabel([state.reprintID], state.reprintTrackingCode)
        return result
      }

      const handleRePrintPackageList = async () => {
        const result = await printPackageList([state.reprintID], state.reprintTrackingCode)
        return result
      }

      const handleUpdateOperationComment = async (rmaRecord) => {
        formRef.value.validate().then(() => {
          const apiCall = async () => {
            try {
              await updateOperationComment(rmaRecord.id, formState.fcomments, rmaRecord.store_mail)
              notification.success({
                message: t('route.success'),
                description: t('route.RMAFactoryRemarkUpdated')
              })
            } catch(error) {
              console.log(error, "handleUpdateOperationComment")
            }
          }
          Modal.confirm({
            title: t('route.confirmRemark'),
            icon: createVNode(ExclamationCircleOutlined),
            okType: 'primary',
            onOk() {
              apiCall()
              context.emit('updateData', currentShowRMA.value.id)
              // currentShowRMA.value.fcomments = formState.fcomments
              formState.fcomments = ""
            },
            onCancel() {
              // console.log('Cancel');
            }
          });
        })
      }

      const handleUpdateStoreComment = async (rmaRecord) => {
        formRef.value.validate().then(() => {
          const apiCall = async () => {
            try {
              await updateStoreComment(rmaRecord.id, formState.scomments)
              notification.success({
                message: t('route.success'),
                description: t('route.RMAStoreRemarkUpdated')
              })
            } catch(error) {
              console.log(error, "handleUpdateStoreComment")
            }
          }
          Modal.confirm({
            title: t('route.confirmRemark'),
            icon: createVNode(ExclamationCircleOutlined),
            okType: 'primary',
            onOk() {
              apiCall()
              context.emit('updateData', currentShowRMA.value.id)
              // currentShowRMA.value.scomments = formState.scomments
              formState.scomments = ""
            },
            onCancel() {
              // console.log('Cancel');
            }
          });
        })
      }

      const handleCancelRMA = (rmaRecord) => {
        Modal.confirm({
          title: t('table.confirm'),
          icon:  createVNode(ExclamationCircleOutlined),
          content: t('route.confirmCanceled'),
          okText: t('table.confirm'),
          cancelText: t('table.cancel'),
          async onOk() {
            try {
              const post_data = {
                id: rmaRecord.id,
                rma_status_id: 17
              }
              await updateRmaStatus(post_data);
              // updateRmaStatus(rmaRecord.id, 17, "");
              notification.success({
                message: t('route.success'),
                description: t('route.RMAHasBeenCanceled')
              })
              context.emit('updateData', '')
              // const index = state.listRmaData.data.findIndex(rma => rma.id == rmaRecord.id);
              // if (index) {
              //   state.listRmaData.data[index].RmaStatus.ID = 17;
              //   state.listRmaData.data[index].RmaStatus.Name = "Cancel Package";
              //   state.listRmaData.data[index].RmaStatus.rma_status_id = 17 ;
              // }
              state.modalShowRMADetail = false
            }
            catch(err) {
              console.log(err)
            }
          },
        });
      };

      const confirmPickup = (rmaRecord) => {
        if (rmaRecord.signUrl == "") {
          state.isShowSign = true;
        } else {
          Modal.confirm({
            title: t('route.confirmPickup'),
            icon: createVNode(ExclamationCircleOutlined),
            okType: 'primary',
            async onOk() {
              const post_data = {
                id: rmaRecord.id,
                rma_status_id: 16
              }
              updateRmaStatus(post_data);
              // updateRmaStatus(rmaRecord.id, 16, "");

              notification.success({
                message: t('route.success'),
                description: t('route.RMAHasBeenUpdated')
              })
              context.emit('updateData', currentShowRMA.value.id)
              // const index = state.listRmaData.data.findIndex(rma => rma.id == rmaRecord.id);
              // if (index) {
              //   state.listRmaData.data[index].RmaStatus.ID = 16;
              //   state.listRmaData.data[index].RmaStatus.Name = "Client Received";
              //   state.listRmaData.data[index].RmaStatus.rma_status_id = 16 ;
              // }

              // let params = `rma_id=${rmaRecord.key}`
              // let someOfData = await getSomeOfRmaListData(params);
              // currentShowRMA.value.RmaStatusHistory = someOfData.data[0].RmaStatusHistory;
              // currentShowRMA.value.rma_status_id = someOfData.data[0].rma_status_id;
              // currentShowRMA.value.RmaStatus.Name = someOfData.data[0].RmaStatus.Name;
              // state.modalShowRMADetail = false
            },
            onCancel() {
              // console.log('Cancel');
            }
          });
        }
      };

      const reject = (rmaRecord) => {
        if (!rmaRecord.canReject) {
          notification.error({
            message: t('route.error'),
            description: t('listRMA.canNotRejectReason')
          })
          return
        }
        rejectReasonModel.value = true
      };

      const rejectOperation = (rmaRecord) => {
        rejectReasonModel.value = true
      };

      const handleRejectReasonOk = async () => {
        if (!state.rejectReasonValue) {
          notification.error({
            message: t('route.error'),
            description: t('listRMA.pleaseSelectRejectReason')
          })
          return
        }
        let post_data = {
          id: currentShowRMA.value.id,
          rma_status_id: isShop ? 18 : 19,
          [isShop ? 'rejected_by_store' : 'rejected_by_operation']: state.rejectReasonValue
        }
        await updateRmaStatus(post_data);
        notification.success({
          message: t('route.success'),
          description: t('route.RMAHasBeenUpdated')
        })
        // if (isShop) {
        //   const index = state.listRmaData.data.findIndex(rma => rma.id == currentShowRMA.value.id);
        //   if (index) {
        //     state.listRmaData.data[index].RmaStatus.ID = 18;
        //     state.listRmaData.data[index].RmaStatus.Name = "Rejected By Store";
        //     state.listRmaData.data[index].RmaStatus.rma_status_id = 18 ;
        //   }
        // } else {
        //   /* const index = state.listRmaData.data.findIndex(rma => rma.id == rmaRecord.id);
        //   if (index) {
        //     state.listRmaData.data[index].RmaStatus.ID = 19;
        //     state.listRmaData.data[index].RmaStatus.Name = "Rejected By Operation";
        //     state.listRmaData.data[index].RmaStatus.rma_status_id = 19 ;
        //   } */
        // }
        context.emit('updateData', '')
        state.modalShowRMADetail = false
        rejectReasonModel.value = false
      }

      const covertToCamelCase = (str) => {
        return str.replace(/\s/g, "")
      }

      // 签名返回上一步
      const undoFn = () => {
        proxy.$refs.signaturePad.undoSignature();
      }

      // 全部清除签名
      const clearFn = () => {
        proxy.$refs.signaturePad.clearSignature();
      }

      // 关闭签名弹窗，清空画布避免下次打开残留
      const closeSignFn = () => {
        proxy.$refs.signaturePad && proxy.$refs.signaturePad.clearSignature();
        state.isShowSign = false;
      }

      // 保存签名
      const saveFn = async (rmaRecord) => {
        const { isEmpty, data } = proxy.$refs.signaturePad.saveSignature();
        const params = {
          RmaId: currentShowRMA.value.RmaID,
          CustomerId: currentShowRMA.value.id.toString(),
          ImageData: data
        }
        let result = await fetchSaveSign(params);
        rmaRecord.signUrl = result.data+'?v='+new Date().getTime();
        setSelectedItem(rmaRecord);
        currentShowRMA = selectedItem;
        if (result.success) {
          closeSignFn();
          Modal.confirm({
            title: t('route.confirmPickup'),
            icon: createVNode(ExclamationCircleOutlined),
            okType: 'primary',
            async onOk() {
              const post_data = {
                id: rmaRecord.id,
                rma_status_id: 16
              }
              await updateRmaStatus(post_data);
              // updateRmaStatus(rmaRecord.id, 16, "");
              notification.success({
                message: t('route.success'),
                description: t('route.RMAHasBeenUpdated')
              })
              context.emit('updateData', currentShowRMA.value.id)
              // const index = state.listRmaData.data.findIndex(rma => rma.id == rmaRecord.id);
              // if (index) {
              //   state.listRmaData.data[index].RmaStatus.ID = 16;
              //   state.listRmaData.data[index].RmaStatus.Name = "Client Received";
              //   state.listRmaData.data[index].RmaStatus.rma_status_id = 16;
              // }
              // let params = `rma_id=${rmaRecord.key}`
              // let someOfData = await getSomeOfRmaListData(params);
              // currentShowRMA.value.RmaStatusHistory = someOfData.data[0].RmaStatusHistory;
              // currentShowRMA.value.rma_status_id = someOfData.data[0].rma_status_id;
              // currentShowRMA.value.RmaStatus.Name = someOfData.data[0].RmaStatus.Name;
              // state.modalShowRMADetail = false
            },
            onCancel() {
              // console.log('Cancel');
            }
          });
        } else {
          Modal.confirm({
            title: 'error',
            icon: createVNode(ExclamationCircleOutlined),
            okType: 'primary',
            onOk() {
              closeSignFn();
            },
            onCancel() {
              // console.log('Cancel');
            }
          });
        }
      }

      const modalClose = () => {
        fcomments_activeKey.value = ''
        scomments_activeKey.value = ''
        state.modalShowRMADetail = false
      }

      const fakeProductModel = ref(false)
      const fakeInfoState = reactive({
        fileList: [],
        remark: ''
      })
      const previewVisible = ref(false)
      const previewImage = ref('')

      const handleCancel = () => { previewVisible.value = false }

      const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        });
      }

      const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
          file.preview = (await getBase64(file.originFileObj));
        }
        previewImage.value = file.url || file.preview;
        previewVisible.value = true;
      }

      const beforeUpload = (file) => {
        fakeInfoState.fileList = [...fakeInfoState.fileList, file]
        return false;
      };

      const uploadFakesInfo = () => {
        fakeProductModel.value = true
      }

      const closeFakesInfoModel = () => {
        fakeProductModel.value = false
        fakeInfoState.fileList = []
        fakeInfoState.remark = ''
      }

      const handleFakeProductOk = async () => {
        const formData = new FormData()
        if (fakeInfoState.fileList.length == 0) {
          notification.error({
            message: t('route.error'),
            description: t('productDetail.pleaseUploadImage')
          })
          return
        }
        if (fakeInfoState.remark == '') {
          notification.error({
            message: t('route.error'),
            description: t('productDetail.pleaseInputRemark')
          })
          return
        }
        if (currentShowRMA.value.RmaItemFakeProduct.id != 0) {
          formData.append("id", currentShowRMA.value.RmaItemFakeProduct.id)
        }
        formData.append("rma_item_id", currentShowRMA.value.id)
        formData.append("fake_remark", fakeInfoState.remark)
        for (let i = 0; i < fakeInfoState.fileList.length; i++) {
          const attachment = await compressImage(fakeInfoState.fileList[i].originFileObj)
          formData.append('attachment', attachment);
        }
        const result = await uploadFakeProduct(formData)
        if (result.success) {
          closeFakesInfoModel()
          context.emit('updateData', currentShowRMA.value.id)
        } else {
          notification.error({
            message: t('route.error'),
            description: result.message
          })
        }
        
        // async function compressImage(img) {
        //   const options = {
        //     maxSizeMB: .5,
        //     maxWidthOrHeight: 1920,
        //     useWebWorker: true
        //   }
        //   const compressedimg = await imageCompression(img, options);
        //   return compressedimg;
        // }
      }

      const editTrackingNumber = async () => {
        editTrackingNumberModel.value = true
      }

      const closeTrackingNumberModel = async () => {
        selectDelivery.value = ''
        newTrackingNumber.value = ''
        editTrackingNumberModel.value = false
      }

      const handleEditTrackingNumberOk = async () => {
        if (selectDelivery.value == '') {
          return notification.error({
            message: t('route.error'),
            description: t('productDetail.pleaseSelectDelivery')
          })
        } else if (newTrackingNumber.value == '') {
          return notification.error({
            message: t('route.error'),
            description: t('productDetail.pleaseInputNewTrackingNumber')
          })
        } else {
          const data = {
            rma_item_id: currentShowRMA.value.id,
            wh_carrier_name: selectDelivery.value,
            wh_carrier_code: newTrackingNumber.value.replace(/\s/g, ''),
          }
          const result = await postUpdateTrackingNumber(data)
          if (result.success) {
            notification.success({
              message: t('route.success'),
              description: t('route.RMAHasBeenUpdated')
            })
            context.emit('updateData', currentShowRMA.value.id)
            closeTrackingNumberModel()
          } else {
            notification.error({
              message: t('route.error'),
              description: result.message
            })
          }
        }
      }

      const showQrcode = (type, title) => {
        let qrcodeText = ''
        if (type == 'phoneQrcode') {
          qrcodeText = `tel:+${currentShowRMA.value.phone_code}${currentShowRMA.value.phone}`
        } else if (type == 'whatsappQrcode') {
          qrcodeText = `https://wa.me/+${currentShowRMA.value.phone_code}${currentShowRMA.value.phone}`
        }
        qrcodeState.qrcodeTitle = title
        qrcodeState.qrcodeVisible = true
        nextTick(() => {
          if (!qrcodeState.qrcodePlugin) {
            qrcodeState.qrcodePlugin = new QRCode("qrcode", {
              text: qrcodeText,
              width: 256,
              height: 256,
              colorDark : "#000000",
              colorLight : "#ffffff",
              correctLevel : QRCode.CorrectLevel.H
            });
          } else {
            qrcodeState.qrcodePlugin.clear();
            qrcodeState.qrcodePlugin.makeCode(qrcodeText)
          }
        })
      }

      const closeQrcodeModal = () => {
        qrcodeState.qrcodeTitle = ''
        qrcodeState.qrcodeVisible = false
      }

      const onSubmitPickupFollowup = async () => {
        if (!contactResult.value) {
          return notification.error({
            message: t('route.error'),
            description: t('productDetail.pleaseSelectDelivery')
          })
        } else {
          const data = {
            rma_item_id: currentShowRMA.value.id,
            content: contactResult.value
          }
          const result = await postUpdateAfterSales(data)
          if (result.success) {
            notification.success({
              message: t('route.success'),
              description: t('route.RMAHasBeenUpdated')
            })
            contactResult.value = undefined
            getPickupFollowUpList(currentShowRMA.value.id)
            // context.emit('updateData', currentShowRMA.value.id)
          } else {
            notification.error({
              message: t('route.error'),
              description: result.message
            })
          }
        }
      }

      const handleUpdateShippingAddress = async () => {
        const shipToCustomer = Number(shippingAddressForm.wh_ship_to_customer) === 1
        if (!shipToCustomer && !shippingAddressForm.store_id) {
          return notification.error({
            message: t('route.error'),
            description: t('productDetail.pleaseSelectStore')
          })
        }
        if (shipToCustomer) {
          if (shippingAddressNeedCountry.value && !shippingAddressForm.customer_country_code) {
            return notification.error({
              message: t('route.error'),
              description: t('createRMA.PleaseSelectCountry')
            })
          }
          if (shippingAddressForm.customer_province == '') {
            return notification.error({
              message: t('route.error'),
              description: t('productDetail.pleaseInputCustomerProvince')
            })
          }
          if (shippingAddressForm.customer_city == '') {
            return notification.error({
              message: t('route.error'),
              description: t('productDetail.pleaseInputCustomerCity')
            })
          }
          if (shippingAddressForm.customer_address == '') {
            return notification.error({
              message: t('route.error'),
              description: t('productDetail.pleaseInputCustomerAddress')
            })
          }
          if (shippingAddressForm.receiver_name == '') {
            return notification.error({
              message: t('route.error'),
              description: t('productDetail.pleaseInputReceiverName')
            })
          }
          if (shippingAddressForm.receiver_phone == '') {
            return notification.error({
              message: t('route.error'),
              description: t('productDetail.pleaseInputReceiverPhone')
            })
          }
        }
        const data = {
          id: shippingAddressOrigin.id,
          wh_ship_to_customer: shipToCustomer ? 1 : 0,
          store_id: shipToCustomer ? shippingAddressOrigin.store_id : String(shippingAddressForm.store_id),
          customer_country_code: shipToCustomer
            ? (shippingAddressNeedCountry.value ? emptyText(shippingAddressForm.customer_country_code) : '')
            : '',
          customer_country_or_reigon: shipToCustomer
            ? (shippingAddressNeedCountry.value ? emptyText(shippingAddressForm.customer_country_or_reigon) : '')
            : '',
          customer_province: shipToCustomer ? emptyText(shippingAddressForm.customer_province) : shippingAddressOrigin.customer_province,
          customer_city: shipToCustomer ? emptyText(shippingAddressForm.customer_city) : shippingAddressOrigin.customer_city,
          customer_area: shipToCustomer ? emptyText(shippingAddressForm.customer_area) : shippingAddressOrigin.customer_area,
          customer_address: shipToCustomer ? emptyText(shippingAddressForm.customer_address) : shippingAddressOrigin.customer_address,
          receiver_name: shipToCustomer ? emptyText(shippingAddressForm.receiver_name) : shippingAddressOrigin.receiver_name,
          receiver_phone: shipToCustomer ? emptyText(shippingAddressForm.receiver_phone) : shippingAddressOrigin.receiver_phone,
          customer_postal_code: shipToCustomer ? emptyText(shippingAddressForm.customer_postal_code) : shippingAddressOrigin.customer_postal_code,
        }
        const result = await postUpdateShippingAddress(data)
        if (result.success) {
          notification.success({
            message: t('route.success'),
            description: t('route.RMAHasBeenUpdated')
          })
          shippingAddressModel.value = false
        } else {
          notification.error({
            message: t('route.error'),
            description: result.message
          })
        }
        context.emit('updateData', currentShowRMA.value.id)
      }

      return {
        formatDateWithTime,
        state,
        currentShowRMA,
        selectedItem,
        reprintLabel,
        handleRePrintLabel,
        handleRePrintPackageList,
        handleCancelRMA,
        confirmPickup,
        reject,
        t,
        locale,
        rejectOperation,
        isShop,
        handleUpdateOperationComment,
        handleUpdateStoreComment,
        scomments_activeKey,
        fcomments_activeKey,
        covertToCamelCase,
        formRef,
        rules,
        formState,
        undoFn,
        clearFn,
        closeSignFn,
        saveFn,
        currentInstance,
        options,
        modalClose,
        rejectReasonModel,
        handleRejectReasonOk,
        fakeProductModel,
        fakeInfoState,
        uploadFakesInfo,
        previewVisible,
        previewImage,
        handleCancel,
        handlePreview,
        beforeUpload,
        handleFakeProductOk,
        closeFakesInfoModel,
        editTrackingNumber,
        closeTrackingNumberModel,
        editTrackingNumberModel,
        delivery_list,
        selectDelivery,
        newTrackingNumber,
        handleEditTrackingNumberOk,
        phoneIcon,
        whatsappIcon,
        qrcodeState,
        showQrcode,
        closeQrcodeModal,
        contactResult,
        onSubmitPickupFollowup,
        shippingAddressModel,
        shippingAddressForm,
        shippingAddressNeedCountry,
        isShipToCustomer,
        handleShipToCustomerChange,
        boutiqueCountryList,
        storeList,
        openShippingAddressModel,
        handleShippingCountryChange,
        handleUpdateShippingAddress
      }
    },
    async mounted(){
      
    }
  })
</script>
<style scoped lang="scss">
.product-detail-model-body {
  margin-bottom: 50px;
}
.link-button {
  color: #fff;
  background-color: #001628 !important;
  border-color: #001628 !important;
  text-shadow: 0 -1px 0 rgb(0 0 0 / 12%);
  box-shadow: 0 2px 0 rgb(0 0 0 / 5%);
  padding: 10px;
}
.ant-collapse-borderless {
  background-color: transparent !important;
}
.remark {
  margin-bottom: 10px;
}
.order-info-col {
  padding-right: 0px;
  padding-left: 0px;

  .product_tracking {
    display: flex;
    align-items: center;
  }

  .phone-col {
    display: flex;
    align-items: center;

    .qrcode-icon {
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-left: 15px;
      cursor: pointer;
    }
  }
}
.factory_reason_box {
  display: flex;
}
.reason_span {
  margin: 0 5px 5px 0;
}
.floatLeft {
  float: left;
}
.marginBottom0 {
  margin-bottom: 0px;
}
.marginBottom8 {
  margin-bottom: 8px;
}
.marginRight20 {
  margin-right: 20px;
}
.paddingBottom8 {
  padding-bottom: 8px;
}
.paddingBottom12 {
  padding-bottom: 12px;
}
.border0 {
  border: 0;
}
.font14 {
  font-size: 14px;
}

.rma-status-text {
  padding: 0 5px;
  &.reject-operation-status {
    background-color: yellow;
  }
}

.footer-btn-box {
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    display: inline-block;
    padding: 4px 0;

    &:last-child {
      margin-right: 0;
    }
  }
  
  .footer-btns {
    text-align: left;    
  }
  .footer-btn-close {}
}

.fakes-into-title {
  display: inline-block;
  width: 150px;
}

.fakes-remark {
  display: inline-block;
  box-sizing: content-box;
  width: 500px;
  // padding-left: 30px;
  font-weight: 600;
}

.qrcode-preview {
  display: flex;
  justify-content: center;
}

.empty-result {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  color: #999;
  
  & > span {
    // width: 90%;
  }

  &::before,
  &::after {
    content: '------';
    white-space: nowrap;
  }
}

.mail-info-box {
  position: relative;

  .mail-info {
    height: 46px;
    position: absolute;
    top: 0;
    left: 0;
  }
}

.factory-remark,
.store-remark {
  height: 46px;
  line-height: 46px;

  .create_by {
    font-weight: 700;
  }
}

.attachment-image {
  border: 2px solid black;
}

.signature-pad-box {
  .signature-pad {
    margin: 0 auto 10px;
    border:2px #cccccc dashed;
  }
  
  .signature-pad-btnbox {
    gap: 8px;
    justify-content: center;
    margin-top: 8px;
  }
}


.pl0 {
  padding-left: 0;
}
.pr0 {
  padding-right: 0;
}
.pt20px {
  padding-top: 20px;
}
.pb20px {
  padding-bottom: 20px;
}
.pb12px {
  padding-bottom: 12px;
}
.mb12px {
  margin-bottom: 12px;
}
.mb24px {
  margin-bottom: 24px;
}
</style>
<style lang="scss">
.fakes-into-images {
  display: flex;
  flex-direction: column;

  .ant-image {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
    .ant-image-img {
      &.desc-images {
        margin-left: 30px;
        border: 1px dashed #cccccc;
      }
      &.fakes-into-image {
        margin-left: 0;
      }
    }
  }
}
.full-modal .ant-modal-body {
  background: white;
}
.fake-product-modal {
  .ant-form-item {
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.fake-product-image-modal {
  .ant-modal-body {
    padding-top: 56px !important;
  }
}

.print-modal {
  display: flex;
  justify-content: space-around;

  .print-modal-left,
  .print-modal-right {
    flex: 1;
    text-align: center;
  }

  .print-modal-left {
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }

  .print-modal-right {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;

    .package {
      display: flex;
    }
  }
}

.modify-shipping-address-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.boutique_country_red {
  margin-left: 10px;
  color: red;
}
.boutique_country_green {
  margin-left: 10px;
  color: green;
}
</style>